// @ts-nocheck
import { GetShipmentsApiParameter } from "@store/Framework/Services/ShipmentService";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<GetShipmentsApiParameter>;

export const DispatchUpdateParameter: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/ShipmentHistory/UpdateParameter",
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateParameter];

const updateParameter = createHandlerChainRunnerOptionalParameter(chain, {}, "UpdateParameter");
export default updateParameter;
